<div fxLayout="row" class="container" fxFlex="100" fxLayoutAlign="space-between" [formGroup]="formGroup">
  <!-- First column -->
  <div class="column" fxLayout="column" fxFlex="24">
    <div class="control">
      <mat-form-field appearance="outline">
        <mat-label>{{ 'EmploymentConditionsConfirmationListFilters.Company' | translate }}</mat-label>
        <input
          matInput
          formControlName="company"
          [placeholder]="'EmploymentConditionsConfirmationListFilters.Company' | translate"
          [matAutocomplete]="autocompleteCompany"
          [errorStateMatcher]="matcher"
          tabindex="1"
          />
          <mat-autocomplete #autocompleteCompany="matAutocomplete" [displayWith]="displayValue">
            @for (company of companies$ | async; track company) {
              <mat-option [value]="company">
                {{ company.Name }}
              </mat-option>
            }
          </mat-autocomplete>
        </mat-form-field>
      </div>

      <div class="control">
        <mat-form-field appearance="outline">
          <mat-label>{{ 'EmploymentConditionsConfirmationListFilters.LastName' | translate }}</mat-label>
          <input matInput type="text" formControlName="lastName" tabindex="5" />
        </mat-form-field>
      </div>

      <div class="control">
        <mat-form-field appearance="outline">
          <mat-label>{{ 'EmploymentConditionsConfirmationListFilters.EmploymentDate' | translate }}</mat-label>
          <mat-date-range-input [rangePicker]="employmentDatePicker">
            <input matStartDate formControlName="employmentDateFrom" [placeholder]="'StartDate' | translate" tabindex="9" />
            <input matEndDate formControlName="employmentDateTo" [placeholder]="'EndDate' | translate" />
          </mat-date-range-input>
          <mat-datepicker-toggle matSuffix [for]="employmentDatePicker"></mat-datepicker-toggle>
          <mat-date-range-picker panelClass="with-tooltip" #employmentDatePicker></mat-date-range-picker>
        </mat-form-field>
      </div>
    </div>

    <!-- Second column -->
    <div class="column" fxLayout="column" fxFlex="24">
      <div class="control">
        <mat-form-field appearance="outline">
          <mat-label>{{ 'EmploymentConditionsConfirmationListFilters.Employer' | translate }}</mat-label>
          <input
            matInput
            formControlName="employer"
            placeholder="{{ 'Employer' | translate }}"
            [matAutocomplete]="autocompleteEmployer"
            [errorStateMatcher]="matcher"
            tabindex="2"
            />
            <mat-autocomplete #autocompleteEmployer="matAutocomplete" [displayWith]="displayValue">
              @for (employer of employers$ | async; track employer) {
                <mat-option [value]="employer">
                  {{ employer.Name }}
                </mat-option>
              }
            </mat-autocomplete>
          </mat-form-field>
        </div>

        <div class="control">
          <mat-form-field appearance="outline">
            <mat-label>{{ 'EmploymentConditionsConfirmationListFilters.FirstName' | translate }}</mat-label>
            <input matInput type="text" formControlName="firstName" tabindex="6" />
          </mat-form-field>
        </div>

        <div class="control">
          <mat-form-field appearance="outline">
            <mat-label>{{ 'EmploymentConditionsConfirmationListFilters.ShareDate' | translate }}</mat-label>
            <mat-date-range-input [rangePicker]="shareDatePicker">
              <input matStartDate formControlName="shareDateFrom" [placeholder]="'StartDate' | translate" tabindex="10" />
              <input matEndDate formControlName="shareDateTo" [placeholder]="'EndDate' | translate" />
            </mat-date-range-input>
            <mat-datepicker-toggle matSuffix [for]="shareDatePicker"></mat-datepicker-toggle>
            <mat-date-range-picker panelClass="with-tooltip" #shareDatePicker></mat-date-range-picker>
          </mat-form-field>
        </div>
      </div>
      <!-- Third column -->
      <div class="column" fxLayout="column" fxFlex="24">
        <div class="control">
          <mat-form-field appearance="outline">
            <mat-label>{{ 'EmploymentConditionsConfirmationListFilters.EmployerObject' | translate }}</mat-label>
            <input
              matInput
              formControlName="employerObject"
              [placeholder]="'EmploymentConditionsConfirmationListFilters.EmployerObject' | translate"
              [matAutocomplete]="autocompleteEmployerObject"
              [errorStateMatcher]="matcher"
              tabindex="3"
              />
              <mat-autocomplete #autocompleteEmployerObject="matAutocomplete" [displayWith]="displayValue">
                @for (employerObject of employerObjects$ | async; track employerObject) {
                  <mat-option [value]="employerObject">
                    {{ employerObject.Name }}
                  </mat-option>
                }
              </mat-autocomplete>
            </mat-form-field>
          </div>
          <div class="control">
            <mat-form-field appearance="outline">
              <mat-label>{{ 'EmploymentConditionsConfirmationListFilters.EmploymentType' | translate }}</mat-label>
              <mat-select formControlName="employmentTypeId" multiple tabindex="7">
                @for (type of employmentType$ | async; track type) {
                  <mat-option #matOption [value]="type.Id">{{ type.Name | translate }}</mat-option>
                }
              </mat-select>
            </mat-form-field>
          </div>
          <div class="control">
            <mat-form-field appearance="outline">
              <mat-label>{{ 'EmploymentConditionsConfirmationListFilters.FirstDownload' | translate }}</mat-label>
              <mat-date-range-input [rangePicker]="firstDownloadDatePicker">
                <input matStartDate formControlName="firstDownloadDateFrom" [placeholder]="'StartDate' | translate" tabindex="11" />
                <input matEndDate formControlName="firstDownloadDateTo" [placeholder]="'EndDate' | translate" />
              </mat-date-range-input>
              <mat-datepicker-toggle matSuffix [for]="firstDownloadDatePicker"></mat-datepicker-toggle>
              <mat-date-range-picker panelClass="with-tooltip" #firstDownloadDatePicker></mat-date-range-picker>
            </mat-form-field>
          </div>
        </div>
        <!-- Four column -->
        <div class="column" fxLayout="column" fxFlex="24">
          <div class="control">
            <mat-form-field appearance="outline">
              <mat-label>{{ 'EmploymentConditionsConfirmationListFilters.ConclusionDateFrom' | translate }}</mat-label>
              <mat-date-range-input [rangePicker]="conclusionDatePicker">
                <input matStartDate formControlName="conclusionDateFrom" [placeholder]="'StartDate' | translate" tabindex="4" />
                <input matEndDate formControlName="conclusionDateTo" [placeholder]="'EndDate' | translate" />
              </mat-date-range-input>
              <mat-datepicker-toggle matSuffix [for]="conclusionDatePicker"></mat-datepicker-toggle>
              <mat-date-range-picker panelClass="with-tooltip" #conclusionDatePicker></mat-date-range-picker>
            </mat-form-field>
          </div>
          <div class="control">
            <mat-form-field appearance="outline">
              <mat-label>{{ 'EmploymentConditionsConfirmationListFilters.AgreementType' | translate }}</mat-label>
              <mat-select formControlName="agreementTypeId" multiple tabindex="8">
                @for (type of agreementTypes$ | async; track type) {
                  <mat-option #matOption [value]="type.Id">{{ type.Name | translate }}</mat-option>
                }
              </mat-select>
            </mat-form-field>
          </div>
          <div class="control">
            <mat-form-field appearance="outline">
              <mat-label>{{ 'EmploymentConditionsConfirmationListFilters.EmploymentConditionsConfirmationStatus' | translate }}</mat-label>
              <mat-select formControlName="employmentConditionsConfirmationStatusId" multiple tabindex="12">
                @for (status of employmentConditionsConfirmationStatuses$ | async; track status) {
                  <mat-option #matOption [value]="status.Id">{{
                    status.Name | translate
                  }}</mat-option>
                }
              </mat-select>
            </mat-form-field>
          </div>
          <div class="control">
            <ng-content></ng-content>
          </div>
        </div>
      </div>
